import React from "react";
import { Outlet, useOutletContext } from "react-router-dom";
import {
  AuditOutlined,
  FileTextOutlined,
  LoginOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import PermissionTabsLayout, {
  PermissionTabsRedirect,
} from "../components/PermissionTabsLayout.jsx";
import useIsMobile from "../hooks/useIsMobile";
import './audit-workspace.css';

const AUDIT_TABS = [
  {
    key: "dashboard",
    label: "Tableau de bord",
    mobileLabel: "Dashboard",
    icon: <AuditOutlined />,
    path: "/audit/dashboard",
    permission: "view_audit_logs",
  },
  {
    key: "logs",
    label: "Journal d'audit",
    mobileLabel: "Logs",
    icon: <FileTextOutlined />,
    path: "/audit/logs",
    permission: "view_audit_logs",
  },
  {
    key: "connexions",
    label: "Connexions",
    mobileLabel: "Connexions",
    icon: <LoginOutlined />,
    path: "/audit/connexions",
    permission: "view_audit_logs",
  },
  {
    key: "sessions",
    label: "Sessions actives",
    mobileLabel: "Sessions",
    icon: <TeamOutlined />,
    path: "/audit/sessions",
    permission: "view_audit_logs",
  },
];

export const AuditTabsRedirect = () => (
  <PermissionTabsRedirect tabs={AUDIT_TABS} />
);

const AuditTabsLayout = () => {
  const isMobile = useIsMobile();
  const parentOutletContext = useOutletContext();
  if (isMobile) return <Outlet context={parentOutletContext} />;
  return <PermissionTabsLayout tabs={AUDIT_TABS} className="audit-tabs-layout" />;
};

export default AuditTabsLayout;
